module.exports = __webpack_public_path__ + "img/racecourse-turffontein-turf-standside-2400.985eff12.svg";